module.exports = __webpack_public_path__ + "static/img/content1.24ee6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/content1.png
// module id = r/wE
// module chunks = 0